import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 10px;
`
export const SelectedAddressTitle = styled.h2`
    font-size: 1rem;
    font-weight: normal;
    color: ${ThemeColors.getGrayColor(0.8)};
`

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap 5px
`
